<template>
  <div class="bottomnav" v-if="order">
    <b-modal
      :id="`refuse-order-${order._id}`"
      hide-footer
      :title="`Recusar pedido #${order.seq}?`"
    >
      <p class="my-2">Deseja realmente recusar o pedido?</p>

      <p class="my-0">As seguintes ações acontecerão automaticamente:</p>
      <p class="my-0">
        - Caso o pagamento tenha sido online, o mesmo será estornado;
      </p>

      <b-button variant="danger" class="my-4" :disabled="buttonLoading">
        <div
          v-if="calcelButtonDisabled"
          class="spinner-border text-white"
        ></div>
        <div
          v-else
          class="text-white"
          @click="patchOrder(order, orderStatus.Refused)"
        >
          Sim, quero recusar este pedido
        </div>
      </b-button>
    </b-modal>

    <b-modal
      :id="`cancel-order-${order._id}`"
      hide-footer
      :title="`Cancelar pedido #${order.seq}?`"
    >
      <p class="my-2">Deseja realmente cancelar o pedido?</p>

      <p class="my-0">As seguintes ações acontecerão automaticamente:</p>
      <p class="my-0">
        - Caso o pagamento tenha sido online, o mesmo será estornado;
      </p>
      <p class="my-0">
        - Caso um motoqueiro tenha sido chamado através de integração, o mesmo
        será cancelado;
      </p>

      <b-button
        :disabled="buttonLoading"
        variant="danger"
        class="my-4"
        @click="patchOrder(order, orderStatus.Cancelled)"
      >
        Sim, quero cancelar este pedido
      </b-button>
    </b-modal>

    <template v-if="order.status === orderStatus.PendingApproval">
      <b-button
        :disabled="buttonLoading"
        variant="success"
        class="mr-2"
        @click="patchOrder(order, orderStatus.Approved)"
      >
        Aceitar
      </b-button>

      <b-button
        :disabled="buttonLoading"
        variant="danger"
        class="mr-2"
        v-b-modal="`refuse-order-${order._id}`"
      >
        Recusar
      </b-button>
    </template>
    <template v-else>
      <template
        v-if="
          (order.status === orderStatus.Approved &&
            (order.locationType === locationTypes.Delivery ||
              order.locationType === locationTypes.Totem ||
              locationTypes.TakeAway)) ||
          order.status === orderStatus.WaitingForDelivery
        "
      >
        <b-button
          :disabled="buttonLoading"
          variant="success"
          class="mr-2"
          @click="patchOrder(order, orderStatus.OutForDelivery)"
        >
          {{
            order.locationType === locationTypes.Totem ||
            order.locationType === locationTypes.TakeAway
              ? "Pedido pronto"
              : "Saiu para entrega"
          }}
        </b-button>
      </template>

      <template
        v-if="
          order.status === orderStatus.OutForDelivery ||
          (order.status === orderStatus.Approved &&
            order.locationType === locationTypes.TakeAway)
        "
      >
        <b-button
          :disabled="buttonLoading"
          variant="success"
          class="mr-2"
          @click="patchOrder(order, orderStatus.Delivered)"
        >
          Entregue
        </b-button>
      </template>

      <template
        v-if="
          order.status === orderStatus.Approved &&
          order.locationType === locationTypes.Delivery &&
          hasDeliveryIntegrations
        "
      >
        <b-button
          :disabled="buttonLoading"
          variant="warning"
          class="mr-2"
          @click="patchOrder(order, orderStatus.WaitingForDelivery, true)"
        >
          Solicitar motoboy
        </b-button>
      </template>

      <template
        v-if="
          order.status !== orderStatus.Cancelled &&
          order.status !== orderStatus.Finished &&
          order.status !== orderStatus.Delivered &&
          order.status !== orderStatus.Refused &&
          order.status !== orderStatus.Refunded
        "
      >
        <b-button
          :disabled="buttonLoading"
          variant="danger"
          class="mr-2"
          v-b-modal="`cancel-order-${order._id}`"
        >
          Cancelar
        </b-button>
      </template>

      <template v-if="isIntegrated">
        Código entrega (beedelivery):
        {{ order.integrations.beedelivery.deliveryId }}, preço:
        {{ order.integrations.beedelivery.deliveryId | currency }}
      </template>
    </template>

    <b-button variant="info" class="mr-2" @click="print()"> Imprimir </b-button>

    <b-button variant="info" class="mr-2" @click="nativePrint()">
      Imprimir pelo navegador
    </b-button>
  </div>
</template>

<script>
import CustomSwitch from "@/components/Utils/CustomSwitch.vue";
import { showToast } from "@/helpers/toast";

import {
  getAccessToken,
  getActiveBranch,
  getActiveUser,
  removeActiveBranch,
  removeActiveCompany,
  removeActiveUser,
} from "@/helpers/storage";
import { FeathersVuexFind, FeathersVuexGet } from "feathers-vuex";
import { patch, post } from "@/network/rest";
import Locations from "@/network/locations";
import { mapGetters } from "vuex";
import {
  orderStatus,
  couponType,
  locationType,
} from "@/helpers/translateEnums";
import qz from "qz-tray";
import moment from "moment";
import { print, manualPrint } from "@/helpers/print";
import { addressFormatter } from "@/helpers/textFormatter";
import { getActiveCompany } from "@/helpers/storage";

export default {
  name: "bottom-nav",
  components: {
    CustomSwitch,
    FeathersVuexGet,
  },
  data() {
    return {
      buttonLoading: false,
      calcelButtonDisabled: false,
    };
  },
  beforeCreate() {
    if (!this.$store.getters.isSynced) this.$router.push("/");
  },
  computed: {
    ...mapGetters({
      selectedOrder: "getSelectedOrder",
      enums: "getEnums",
      synced: "isSynced",
    }),
    activeBranch: () => getActiveBranch(),
    activeUser: () => getActiveUser(),
    accessToken: () => getAccessToken(),
    feathers() {
      return this.$FeathersVuex.api;
    },
    order() {
      return this.feathers.Order.getFromStore(this.selectedOrder);
    },
    branch() {
      return this.feathers.Branch.getFromStore(this.activeBranch);
    },
    orderStatus() {
      return this.enums.OrderStatusEnum;
    },
    locationTypes() {
      return this.enums.LocationTypes;
    },
    user() {
      return this.feathers.User.getFromStore(this.order.customer);
    },
    company() {
      return this.feathers.Company.getFromStore(getActiveCompany());
    },
    hasDeliveryIntegrations() {
      const { integrations } = this.branch;

      return (
        integrations &&
        ((integrations.motoboycom && integrations.motoboycom.enabled) ||
          (integrations.beedelivery &&
            integrations.beedelivery.linked &&
            integrations.beedelivery.enabled))
      );
    },
    isIntegrated() {
      const { integrations } = this.order;

      return (
        integrations &&
        integrations.beedelivery &&
        integrations.beedelivery.linked &&
        integrations.beedelivery.enabled
      );
    },
  },
  methods: {
    async patchOrder(order, newStatus, bee) {
      this.calcelButtonDisabled = true;
      this.buttonLoading = true;
      const scheduled =
        order.scheduledOrder &&
        order.scheduledOrder.scheduled &&
        (newStatus == 8 || newStatus == 16 || newStatus == 32);

      try {
        const data = `${Locations.statuses}?$client[id]=${
          order._id
        }&$client[status]=${newStatus}${bee ? "&$client[bee]=true" : ""}${
          scheduled ? "&$client[removeSchedule]=true" : ""
        }`;
        await post(this.accessToken, data, order);
        this.$bvModal.hide(`refuse-order-${order._id}`);
      } catch (e) {
        console.log(e);
        showToast(
          this,
          `Algum erro ocorreu, atualize a página e tente novamente`,
          "danger"
        );
      } finally {
        this.calcelButtonDisabled = false;
        this.buttonLoading = false;
      }
    },
    print() {
      print(this, this.enums, this.order, this.company, this.branch, this.user);
    },
    nativePrint() {
      manualPrint();
    },
    translateStatus(status) {
      return orderStatus(this, status);
    },
    translateLocation(location) {
      return locationType(this, location);
    },
    formatAddress(location) {
      return addressFormatter(location);
    },
  },
};
</script>

<style lang="scss" scoped>
.bottomnav {
  background-color: #fff;
  height: $topnav-height;
  width: 100%;
  border-radius: 5px;
  box-shadow: $shadow;
  display: flex;
  align-items: center;
  padding: 0 15px;
}

.icon-user {
  color: $text-color;
  font-size: 2rem;
}

.icon-dropdown {
  font-size: 1.2rem;
}

.icon-menu {
  cursor: pointer;
  font-size: 2rem;
  display: none;

  @media (max-width: 1150px) {
    display: block;
  }
}
</style>
